/**
 * Entry point: loads custom fonts, declares the visual theme, then boots
 * the game.
 *
 * Wrapped in an async IIFE because the game's Vite build target is ES2015
 * (for legacy browser support) and top-level await would need ES2022.
 *
 * The fonts MUST be loaded before bootGame() runs, otherwise Phaser
 * caches its text glyphs in the system fallback font and never updates
 * them when the real font finishes loading.
 *
 * Two Kaph variants are registered as the same family with different
 * `style` descriptors so Phaser text with `fontStyle: 'italic'` picks
 * up the italic file automatically.
 */
import { bootGame, Fonts, Theme } from '@platform/sdk';
import GameScene from './GameScene.js';
import manifest from '../manifest.json';

(async function start() {
  await Fonts.load([
    { family: 'Kaph', url: 'assets/fonts/Kaph-Regular.woff2', descriptors: { style: 'normal' } },
    { family: 'Kaph', url: 'assets/fonts/Kaph-Italic.woff2',  descriptors: { style: 'italic' } }
  ]);

  // Override the SDK's default font so every shell scene picks Kaph up.
  Theme.font.family = '"Kaph", system-ui, sans-serif';

  bootGame({
    manifest,
    GameScene,
    parent: 'game',
    // Front camera so the player can wave their hands at the screen.
    cameraFacing: 'user',
    // Pixel-art rendering: nearest-neighbour filtering, no antialias.
    pixelArt: true,
    // Per-game visual theme.
    theme: {
      backgrounds: {
        MainMenu: 'bg_menu',
        Lobby:    'bg_lobby',
        About:    'bg_about',
        GameOver: 'bg_gameover'
      },
      buttons: {
        primary:   { textureKey: 'btn_primary' },
        secondary: { textureKey: 'btn_secondary' },
        danger:    { textureKey: 'btn_danger' }
      }
    }
  });
})();
